import { CallActionType } from './call-action';
import { testDataCreator } from '@wix/answers-lib';
import { CallPriority } from '../../call';
export var routeToIvrActionBuilder = testDataCreator({
    type: CallActionType.ROUTE_TO_IVR,
    ivrId: 'b0b-b0b-b0b'
});
export var routeToQueueActionBuilder = testDataCreator({
    type: CallActionType.ROUTE_TO_QUEUE,
    queueId: 'q0q-q0q-q0q',
    callPriority: CallPriority.NORMAL
});
export var hangUpActionBuilder = testDataCreator({
    type: CallActionType.HANGUP
});
export var forwardToPhoneActionBuilder = testDataCreator({
    type: CallActionType.FORWARD_TO_PHONE_NUMBER,
    phoneNumber: {
        number: '',
        countryCode: ''
    }
});
export var callbackUserInputOptionBuilder = testDataCreator({
    input: {
        keyPressed: '0',
        say: 'hang up'
    },
    messages: [],
    action: hangUpActionBuilder({})
});
export var userInputOptionBuilder = testDataCreator({
    input: {
        keyPressed: '0',
        say: 'hang up'
    },
    messages: [],
    action: hangUpActionBuilder({})
});
export var userInputActionBuilder = testDataCreator({
    type: CallActionType.USER_INPUT,
    userInputOptions: []
});
export var numberInputWebhookActionBuilder = testDataCreator({
    type: CallActionType.NUMBER_INPUT_WEBHOOK,
    beforePostMessages: [],
    url: ''
});
export var sendExternalServiceBuilder = testDataCreator({
    type: CallActionType.SEND_TO_EXTERNAL_SERVICE,
    beforePostMessages: [],
    url: ''
});
export var voicemailActionBuilder = testDataCreator({
    type: CallActionType.ROUTE_TO_VOICEMAIL,
    assignTicketEnabled: false,
    prioritizeTicketEnabled: false,
    addTicketLabelsEnabled: false,
    transcribeVoiceMailMessageEnabled: false
});
//# sourceMappingURL=call-action.builder.js.map